/*
 * Project: LegalPlace assistant
 * File: src\redux\actions\contract.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */


export const CREATE_CONTRACT = 'CREATE_CONTRACT';
export const INIT_CONTRACT = 'INIT_CONTRACT'; // load section 0
export const SET_SECTION_ID = 'SET_SECTION_ID';
export const SET_FULL_WIDTH = 'SET_FULL_WIDTH';
export const REPRISE_WIZARD = 'REPRISE_WIZARD';
export const REPRISE_LINK = 'REPRISE_LINK';
export const SET_IS_FINISHED = "SET_IS_FINISHED";
export const REDIRECT_TO_SECTION = "REDIRECT_TO_SECTION";

export function setSection( id, isaNav ) {
    return {
        type: SET_SECTION_ID,
        id: (id > 0) ? id : 0,
        isaNav
    }
}

export function redirectToSection(s_id) {
    return {
        type: REDIRECT_TO_SECTION,
        s_id
    }
}

export function setFullWidth(val) {
  return {
    type: SET_FULL_WIDTH,
    val,
  };
}

export function setRepriseLink( val ) {
  return {
    type: REPRISE_LINK,
    val
  };
}

export function setRepriseWizard(val) {
  return {
    type: REPRISE_WIZARD,
    val,
  };
}
export function setIsFinished( val ) {
  return {
    type: SET_IS_FINISHED,
    val
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/contract.js